/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';

const MODULE_NAME = 'profile.machines.states.triggerFiatPurchase';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const triggerFiatPurchase = async (context: any, event: any) => {
  const currentState = 'TRIGGER_FIAT_PURCHASE';
  const method = 'triggerFiatPurchase';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      if (event?.data?.value?.order_id) {
        await srv?.agent?.getDisplayRazorPayProps({
          order: event?.data?.value,
        });
        return resolve({
          key: 'TRIGGER_FIAT_PURCHASE',
          value: event?.data?.value,
        });
      } else {
        const msg = 'Payment failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'TRIGGER_FIAT_PURCHASE',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'TRIGGER_FIAT_PURCHASE',
        value: err?.message,
      });
    }
  });
};
